import {
  AddButton,
  MediumScreenModel,
} from "components";
import { useEffect, useState } from "react";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import { fetchDcddUsers } from "../state/action";
import { connect } from "react-redux";
import HandleCreateDcddUser from "./HandleCreateDcddUser";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';
import ServerTable from "components/table/ServerTable";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const DcddUserTable: React.FC<Props> = ({
  fetchDcddUsers,
  onFetchDcddUsers,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0)
  const [hasNext] = useState(true);
  const openModal = () => setModalOpen(true);
  const [pageIndex, setPageIndex] = useState(0); 
  const dcddUserData = fetchDcddUsers?.dcddUsers?.users;
  useEffect(() => {
    onFetchDcddUsers(limit, offset);
  }, [onFetchDcddUsers, limit, offset]);

 const handlePaginationChange = (newLimit: number, newOffset: number) => {
  const newPageIndex = Math.floor(newOffset / newLimit);
  setLimit(newLimit);
  setOffset(newOffset);
  setPageIndex(newPageIndex);
  onFetchDcddUsers(newLimit, newOffset);
};
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_DCDD_USER));
  return (
    <>
      <ServerTable
        headers={["User Management", "Dcdd Users"]}
        data={dcddUserData}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={<>
          {isPermitted && (
            <AddButton
              onClick={openModal}
              label="Add DCDD User"
              tooltip="Add new DCDD user" />
          )}
        </>}
        onPaginationChange={handlePaginationChange} 
        pageIndex={pageIndex}
        pageSize={limit}   
        hasNext={hasNext} 
       />
      {isModalOpen && (
        <MediumScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
          <HandleCreateDcddUser onClose={() => setModalOpen(false)} />
        </MediumScreenModel>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchDcddUsers: state.dcddUser.dcddUserState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchDcddUsers: (limit:number, offset:number) => dispatch(fetchDcddUsers(limit, offset)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DcddUserTable);
